import React, { useState, useEffect } from "react";
import styles from "./add_another.module.css";
import { Checkbox } from "@mui/material";
import DividerLine from "ui/crfs/divider_line";
import LoadingButton from "@mui/lab/LoadingButton";
import { cloneDeep } from "lodash";
import router from "routes";

export default function AddAnother(props) {
  const { field, crf_id, subject_id, visit_index, field_array } = props;

  const display_another = () => {
    let compared_field = null;
    if (field.display_logic?.rules) {
      compared_field = field_array?.find((f) => f.id === parseInt(field.display_logic?.rules[0]?.field_id));
    } else if (field.display_logic?.field_id) {
      //this is for backwards compatibility before the rule was an array
      compared_field = field_array?.find((f) => f.id === parseInt(field.display_logic?.field_id));
    }

    if (compared_field?.value_obj?.value && compared_field?.value_obj?.value !== "") {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className={styles.outer_wrapper}>
      <div className={styles.input_flex}>
        <div className={styles.column}>
          <LoadingButton
            variant="contained"
            loading={false}
            onClick={() => router.navigate(`/subjects/${subject_id}/edc/visit/${visit_index}/multi_entry/${crf_id}`)}
            sx={{
              fontSize: 14,
              padding: "2px",
              paddingLeft: "10px",
              paddingRight: "10px",
            }}
          >
            Go Back
          </LoadingButton>
        </div>
        <div className={styles.column}>
          {display_another() ? (
            <LoadingButton
              variant="contained"
              loading={false}
              onClick={() =>
                router.navigate(
                  `/subjects/${subject_id}/edc/visit/${visit_index}/multi_entry/${crf_id}/${crypto.randomUUID()}`
                )
              }
              sx={{
                fontSize: 14,
                padding: "2px",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}
            >
              Add Another
            </LoadingButton>
          ) : null}
        </div>
      </div>
      <DividerLine />
    </div>
  );
}
